import React from 'react'
import Dialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'

import DialogTitle from '~/components/DialogTitle'
import CountryField from '~/components/Fields/CountryField'
import EmailField from '~/components/Fields/EmailField'
import PhoneNumberField from '~/components/Fields/PhoneNumberField'
import TextField from '~/components/Fields/TextField'
import { Button, DiscardButton } from '~/components/Buttons'
import { withForm } from '~/components/Form'

function SupplierDialogForm ({ onClose, form, ...props }) {
  const { handleSubmit } = form
  const { t } = useTranslation()

  return (
    <Dialog maxWidth="md" onClose={onClose} {...props}>
      <form onSubmit={handleSubmit}>
        <DialogTitle component="h3" variant="h6">
          Create supplier
        </DialogTitle>
        <DialogContent dividers={true}>
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12}>
              <Typography variant="h6" gutterBottom={true}>{t('GENERAL')}</Typography>
              <Grid container={true} spacing={2}>
                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="companyName"
                    name="companyName"
                    label="Company Name"
                    required={true}
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="shortName"
                    name="shortName"
                    label="Short name"
                    required={true}
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <EmailField
                    data-cy="email"
                    name="email"
                    label="Email"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <PhoneNumberField
                    data-cy="phoneNumber"
                    name="phoneNumber"
                    label="Phone number"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="referenceId"
                    name="referenceId"
                    label="Reference id"
                  />
                </Grid>
              </Grid>

              <Box mt={3}>
                <Typography variant="h6" gutterBottom={true}>{t('ADDRESS')}</Typography>
              </Box>
              <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                  <TextField
                    data-cy="address"
                    name="address"
                    label="Address"
                    multiline={true}
                    minRows={3}
                  />
                </Grid>

                <Grid item={true} xs={12} lg={12}>
                  <CountryField
                    data-cy="country"
                    name="country"
                    label="Country"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="city"
                    name="city"
                    label="City"
                    country="country"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="zipcode"
                    name="zipcode"
                    label="Zipcode"
                  />
                </Grid>
              </Grid>
              <Box mt={3}>
                <Typography variant="h6" gutterBottom={true}>{t('PRIMARY CONTACT')}</Typography>
              </Box>
              <Grid container={true} spacing={2}>
                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="contactFirstName"
                    name="contactFirstName"
                    label="First name"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <TextField
                    data-cy="contactLastName"
                    name="contactLastName"
                    label="Last Name"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <EmailField
                    data-cy="contactEmail"
                    name="contactEmail"
                    label="Email"
                  />
                </Grid>

                <Grid item={true} xs={12} lg={6}>
                  <PhoneNumberField
                    data-cy="contactPhoneNumber"
                    name="contactPhoneNumber"
                    label="Phone number"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <DiscardButton
            fullWidth={true}
            onClick={onClose}
          >
            Discard
          </DiscardButton>
          <Button
            variant="contained"
            type="submit"
            fullWidth={true}
          >
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

SupplierDialogForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired
}

export default withForm(SupplierDialogForm)
